import { apiClient, unwrap } from './client';

import type { ApiResponse, FeedbackItem } from '@/types';

export interface FeedbackCreatePayload {
  target_type?: 'submission' | 'none';
  target_id?: number | null;
  category: 'appeal' | 'bug' | 'suggestion';
  content: string;
}

export interface FeedbackCreateResult {
  id: number;
  job_title?: string | null;
  teacher_id?: number | null;
  teacher_name?: string | null;
}

export async function createFeedback(payload: FeedbackCreatePayload): Promise<FeedbackCreateResult> {
  const response = await apiClient.post<ApiResponse<FeedbackCreateResult>>('/feedback', payload);
  return unwrap(response);
}

export async function listFeedback(): Promise<FeedbackItem[]> {
  const response = await apiClient.get<ApiResponse<FeedbackItem[]>>('/feedback');
  return unwrap(response);
}

export async function replyFeedback(
  id: number,
  data: { status: 'resolved' | 'rejected'; reply: string },
): Promise<{ ok: boolean }> {
  const response = await apiClient.post<ApiResponse<{ ok: boolean }>>(
    `/feedback/${id}/reply`,
    data,
  );
  return unwrap(response);
}
